<app-dialog-container>
  <mat-dialog-content class="dialogContent">
    <h1 mat-card-title>SELEÇÃO DE MODULOS</h1>
    <div fxLayout="column" fxLayoutGap="10">
      <div fxLayout="row" fxLayoutGap="10" fxFill>
        <div fxFlex fxLayoutGap="10">
          <div fxLayout="column" fxLayoutGap="10" fxFill>
            <!-- BARRA DE PESQUISA DE PRODUTO -->
            <div fxFlex="50px">
              <div
                fxLayout="row"
                *ngIf="hasFilter"
                fxFlexFill
                fxLayoutAlign="space-between center"
              >
                <div fxFlex>
                  <mat-form-field *ngIf="!hideFilter">
                    <input
                      matInput
                      #input
                      (keyup)="applyFilter($event)"
                      (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
                      (ngModelChange)="keyboardService.onInputChange(input.value, input)"
                      placeholder="Pesquisar"
                    />
                  </mat-form-field>
                </div>
                <button
                  *ngIf="!hideFilter"
                  type="button"
                  mat-fab
                  class="search-add-fab"
                  (click)="confirm()"
                  aria-label="Aplicar seleção">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
            <!-- PRODUTOS -->
            <div fxFlex class="panel">
              <div fxLayout="column" fxFill>
                <div fxFlex="90">
                  <section
                    class="sec-table mat-elevation-z2"
                    [ngClass.gt-xs]="'sec-table-xs'"
                    [ngClass.gt-md]="'sec-table-md'"
                    [ngClass.gt-lg]="'sec-table-lg'"
                    tabindex="0"
                  >
                    <table
                      [ngClass.gt-xs]="'table-xs'"
                      [ngClass.gt-md]="'table-md'"
                      [ngClass.gt-lg]="'table-lg'"
                      mat-table
                      [dataSource]="dataSource"
                    >
                      <!-- Checkbox Column -->
                      <ng-container matColumnDef="isSelected" sticky>
                        <th mat-header-cell *matHeaderCellDef>
                          <div
                            *ngIf="hasValue() && !isAllSelected()"
                            class="slide-toggle-indeterminate"
                            (click)="toggleAllRows()"
                          ></div>
                          <mat-slide-toggle
                            (change)="$event ? toggleAllRows() : null"
                            *ngIf="!(hasValue() && !isAllSelected())"
                            [aria-label]="checkboxLabel()"
                            [checked]="isAllSelected()"
                          >
                          </mat-slide-toggle>
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-slide-toggle
                            (click)="$event.stopPropagation()"
                            (change)="$event ? toggle(row) : null"
                            [checked]="row.isSelected"
                            [aria-label]="checkboxLabel(row)"
                          >
                          </mat-slide-toggle>
                        </td>
                      </ng-container>

                      <ng-container
                        *ngFor="let configColumn of configColumns"
                        matColumnDef="{{ configColumn.property }}"
                      >
                        <th mat-header-cell *matHeaderCellDef>
                          {{ configColumn.display }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <!-- LINK -->
                          <a
                            *ngIf="
                              (configColumn.field_type ===
                                fieldTypeEnum.LABEL ||
                                configColumn.field_type ===
                                  fieldTypeEnum.LABEL_CURRENCY) &&
                              configColumn.link_show
                            "
                            href="javascript:void()"
                            class="disabled_link_on_web"
                          >
                            {{
                              getValue(
                                configColumn,
                                element[configColumn.property]
                              )
                            }}
                          </a>

                          <ng-container
                            *ngIf="
                              (configColumn.field_type ===
                                fieldTypeEnum.LABEL ||
                                configColumn.field_type ===
                                  fieldTypeEnum.LABEL_CURRENCY) &&
                              !configColumn.link_show
                            "
                            >{{
                              getValue(
                                configColumn,
                                element[configColumn.property]
                              )
                            }}</ng-container
                          >

                          <ng-container
                            *ngIf="
                              configColumn.field_type === fieldTypeEnum.IMAGE
                            "
                          >
                            <img
                              class="image-label"
                              [src]="getUrl(element[configColumn.property])"
                            />
                          </ng-container>
                        </td>
                      </ng-container>

                      <tr
                        mat-header-row
                        *matHeaderRowDef="displayedColumns; sticky: true"
                      ></tr>
                      <tr
                        tabindex="999"
                        mat-row
                        *matRowDef="
                          let row;
                          columns: displayedColumns;
                          let i = index
                        "
                        [class.demo-row-is-clicked]="indexSelect === i"
                        class="row"
                        (click)="selectItem(row, i)"
                      ></tr>
                    </table>
                    <mat-paginator
                      [length]="length"
                      [pageSize]="pageSize"
                      [pageSizeOptions]="pageSizeOptions"
                      (page)="pageEvent($event)"
                    ></mat-paginator>
                  </section>
                </div>
              </div>
            </div>
            <!-- OUTRAS OPCOES -->
            <div fxFlex="12"></div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <app-dialog-save-close
    closeText="SAIR"
    saveText="APLICAR"
    [closeOnSave]="false"
    (onSave)="confirm()"
  ></app-dialog-save-close>
</app-dialog-container>
